import * as yup from 'yup'

export const contactFilterFormSchema = yup.object().shape({
  storeName: yup.string(),
  isFavorit: yup.bool()
})
